export default {
  issuerType: 'ECS_Breach',
  offerId: 'eb535534-5bf4-4c7e-b752-5fa984fc8fdb',
};
